<template lang="pug">
  div.container-fuid.px-0
    h2.mt-4 NUTZUNGSBEDINGUNGEN DOWNLOAD-BEREICH
    ol.terms
      li Hinweis zu KI-generierten Bildern: Einige Bildinhalte im MALU WILZ Download-Bereich sind KI-generiert. Diese sind mit dem Tag "AI generated" gekennzeichnet. Seit dem 2. August 2026 besteht gemäß Art. 50 Abs. 2 EU-KI-Verordnung die gesetzliche Pflicht, KI-generierte Bilder bei der Verwendung entsprechend zu kennzeichnen. Die Kennzeichnung muss klar, unterscheidbar und spätestens bei der ersten Wahrnehmung des Inhalts erkennbar sein. Sie darf bei normaler Betrachtung nicht leicht übersehen werden. Wir bitten Sie, dies bei der Nutzung der bereitgestellten Bilder in Ihren eigenen Werbe- und Kommunikationsmaterialien zu berücksichtigen und die Kennzeichnungspflicht entsprechend eigenständig umzusetzen.
      li Die MALU WILZ Beauté Produktfotos dürfen ausschließlich, bis auf Widerruf, für alle Ihre gedruckten Werbemittel (Flyer, Poster, Visitenkarten usw.), sowie die Homepage-Gestaltung genutzt werden. Es ist ausdrücklich untersagt, MALU WILZ Beauté Produktfotos für einen eigenen Online-Shop zu verwenden. Für die Illustration im eigenen Online-Shop können die MALU WILZ Beauté Produktbilder gegen eine Nutzungsgebühr erworben werden. Für nähere Informationen wenden Sie sich dafür bitte an die MALU WILZ Beauté Marketing Abteilung.
      li Es dürfen grundsätzlich nur Bilder verwendet werden, die im Download-Bereich zur Verfügung gestellt werden. Darüber hinaus von MALU WILZ Beauté in Werbemitteln (Prospekte, Behandlungsmappen, Mailingvorschläge, Flyer, etc.) verwendetes Bildmaterial ist ausschließlich für diese Nutzung vorgesehen und darf nicht verwendet, eingescannt oder weiterverarbeitet werden. Bei Zuwiderhandlung übernimmt die MALU WILZ BEAUTÉ GmbH keinerlei Haftung.
      li Modefarben-Motive dürfen grundsätzlich 12 Monate nach Neuerscheinung genutzt werden, weitere Nutzungen unterliegen einer gesonderten Genehmigung.
      li Das gesamte MALU WILZ Beauté Bildmaterial darf nur zu Werbezwecken für die Marke MALU WILZ Beauté sowie MALU WILZ Beauté Dienstleistungen genutzt werden.
      li Das MALU WILZ Beauté Bildmaterial darf nicht verändert werden.
    form.my-3(@submit.prevent)
      div.form-group.form-check.fat-checkbox
        input.form-check-input(type="checkbox" id="agree" v-model="agreed")
        label.form-check-label(for="agree")
          | Ich habe die Nutzungsbedingungen gelesen, verstanden und stimme ihnen zu.
    button.btn.btn-secondary(
      @click="showDownloadArea"
      :class="{ 'btn-success': downloadAreaAgreed }"
      :disabled="!downloadAreaAgreed"
      )
        | Weiter zum Download
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'DownloadAreaAgree',
  computed: {
    ...mapState('ui', [
      'downloadAreaAgreed'
    ]),
    agreed: {
      get () {
        return this.downloadAreaAgreed
      },
      set (newVal) {
        this.setDownloadAreaAgreed(newVal)
      }
    }
  },
  methods: {
    ...mapMutations('ui', [
      'setDownloadAreaAgreed'
    ]),
    ...mapActions('ui', [
      'showDownloadArea'
    ])
  }
}
</script>

<style lang="stylus" scoped>
  ol.terms
    li
      padding 10px 0px
      margin 0px
</style>
